import { render, staticRenderFns } from "./AdminImpressum.vue?vue&type=template&id=186c7a0d&scoped=true"
import script from "./AdminImpressum.vue?vue&type=script&lang=ts"
export * from "./AdminImpressum.vue?vue&type=script&lang=ts"
import style0 from "./AdminImpressum.vue?vue&type=style&index=0&id=186c7a0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c7a0d",
  null
  
)

export default component.exports